export default __webpack_public_path__ + "static/media/banner-phone-nl@2x.aff9b656.png";